import api from './api';

const solicitudService = {
  getSolicitudes: async (params = {}) => {
    try {
      const response = await api.get('/api/solicitudes', { params });
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al obtener solicitudes';
    }
  },

  getSolicitud: async (solicitudId) => {
    try {
      const response = await api.get(`/api/solicitudes/${solicitudId}`);
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al obtener solicitud';
    }
  },

  createSolicitudCambioEstado: async (solicitudData) => {
    try {
      const response = await api.post('/api/solicitudes/cambio-estado', solicitudData);
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al crear solicitud';
    }
  },

  createSolicitudRegistroEquipo: async (solicitudData) => {
    try {
      const response = await api.post('/api/solicitudes/registro-equipo', solicitudData);
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al crear solicitud de registro';
    }
  },

  revisarSolicitud: async (solicitudId, aprobada, comentario = null) => {
    try {
      const response = await api.post(`/api/solicitudes/${solicitudId}/revisar`, {
        aprobada: aprobada,
        comentario: comentario
      });
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al revisar solicitud';
    }
  },

  deleteSolicitud: async (solicitudId) => {
    try {
      await api.delete(`/api/solicitudes/${solicitudId}`);
      return true;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al eliminar solicitud';
    }
  },

  exportarExcel: async (params = {}) => {
    try {
      const response = await api.get('/api/solicitudes/exportar/excel', {
        params,
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        throw error.response.data.detail;
      }
      throw error.message || 'Error al exportar solicitudes';
    }
  }
};

export default solicitudService;